import { Fragment } from 'react';

import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

import type { OrderType } from '~/hooks/useLoaders/usePaginatedComments';

interface Props {
  reorderComments: (order: OrderType) => void;
  commentOrder?: OrderType;
}

interface OrderOptionProps extends Props {
  text: string;
  order: OrderType;
}

const OrderOption = ({ text, reorderComments, order }: OrderOptionProps) => {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={() => reorderComments(order)}
          className={`${
            active ? 'bg-wt-text-on-background text-wt-background' : 'text-wt-text-on-background'
          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
        >
          {text}
        </button>
      )}
    </Menu.Item>
  );
};

const CommentOptionsOrderingDropdown = ({ reorderComments, commentOrder }: Props) => {
  const OPTIONS = {
    desc: 'Newest first',
    asc: 'Oldest first',
    popular: 'Most popular',
  };

  return (
    <div className="">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex w-full justify-center whitespace-nowrap rounded-wt border bg-wt-background px-4 py-1 text-sm font-medium text-wt-text-on-background">
            {OPTIONS[commentOrder || 'desc']}
            <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5 text-wt-text-on-background" aria-hidden="true" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-md border bg-wt-background shadow-lg">
            <div className="px-1 py-1">
              <OrderOption text={OPTIONS.desc} order="desc" reorderComments={reorderComments} />
              <OrderOption text={OPTIONS.asc} order="asc" reorderComments={reorderComments} />
              <OrderOption text={OPTIONS.popular} order="popular" reorderComments={reorderComments} />
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default CommentOptionsOrderingDropdown;
